import React from 'react'
import {Button} from "antd";
import {Link} from "@reach/router";

const ShippingOrderEdit = ({shipping}) => {
    
    return(
        <React.Fragment>
            <Button type={"link"} >
                <Link to={`/landing/shipping-order/edit/${shipping.id}`}>Düzenle</Link>
            </Button>
        </React.Fragment>
    )
}
export default ShippingOrderEdit